// extracted by mini-css-extract-plugin
module.exports = {"item":"F_cx","item__image":"F_cy"};